// extracted by mini-css-extract-plugin
export default {"manager":"ReleaseManagers_manager__1rELz","managers":"ReleaseManagers_managers__mw-Uh"};